import React, {useEffect, useState} from "react";
import Nav from "../components/nav/Nav";
import styled from "styled-components";
import TagsSectionSetting from "../components/tag/TagsSectionSetting";
import tagSVG from '../images/tag.svg'
import usersSVG from '../images/groups.svg'
import securitySVG from '../images/security.svg'
import archiveSVG from '../images/project/archive.svg'
import personalizeSVG from '../images/personalize.svg'
import {Link, useLocation} from "react-router-dom";
import UsersSection from "../components/user/UsersSection";
import AccountSecurity from "../components/account/AccountSecurity";
import {
    ARCHIVE_ROUTE,
    MY_ACCOUNT, PERSONALISATION_ROUTE,
    SECURITY_ROUTE,
    TAGS_ROUTE,
    USERS_ROUTE
} from "../routes/routesName";
import {useSelector} from "react-redux";
import {ROLE_AMBASSADOR, ROLE_CODIR, ROLE_ENJOY} from "../permissions/roleTypes";
import CurrentUserAccount from "../components/account/CurrentUserAccount";
import ArchivedProjects from "../components/project/ArchivedProjects";
import ProtectedRoutesOnlyAdmin from "../routes/ProtectedRoutesOnlyAdmin";
import PersonalisationSection from "../components/strategy/PersonalisationSection";

const SettingsPage = () => {
    const [navIsOpen, setNavIsOpen] = useState(false)
    const {pathname} = useLocation()
    const {roles} = useSelector(state => state.currentUser)
    const [choices, setChoices] = useState([])
    const location = useLocation()
    const path = location.pathname.split("/")[1]

    useEffect(() => {
        let filteredChoices = [
            {
                id: "tags",
                name: "Tags",
                link: TAGS_ROUTE,
                image: tagSVG,
            },
            {
                id: "users",
                name: "Utilisateurs",
                link: USERS_ROUTE,
                image: usersSVG,
            },
            {
                id: "security",
                name: "Sécurité",
                link: SECURITY_ROUTE,
                image: securitySVG,
            }]

        if (roles.includes(ROLE_CODIR) || roles.includes(ROLE_AMBASSADOR) || roles.includes(ROLE_ENJOY)) {
            const addedChoices = [

                {
                    id: "archives",
                    name: "Archives",
                    link: ARCHIVE_ROUTE,
                    image: archiveSVG,
                },
                {
                    id: "personalisation",
                    name: "Personnalisation",
                    link: PERSONALISATION_ROUTE,
                    image: personalizeSVG,
                },
            ]

            addedChoices.forEach((c) => {
                if (c.id !== "archives" && c.id !== "personalisation") {
                    filteredChoices.unshift(c)
                } else {
                    filteredChoices.push(c)
                }
            })
        }
        setChoices(filteredChoices)
    }, [roles])

    const displaySections = () => {
        if (location.pathname === TAGS_ROUTE) {
            return <TagsSectionSetting/>
        }
        if (location.pathname === USERS_ROUTE) {
            return <UsersSection/>
        }

        if (location.pathname.includes(SECURITY_ROUTE)) {
            return <AccountSecurity/>
        }

        if (location.pathname === ARCHIVE_ROUTE) {
            return <ProtectedRoutesOnlyAdmin><ArchivedProjects/></ProtectedRoutesOnlyAdmin>
        }
        if (location.pathname === PERSONALISATION_ROUTE) {
            return <PersonalisationSection/>
        }

    }

    return (
        <Page>
            <Nav
                setNavIsOpen={setNavIsOpen}
                navIsOpen={navIsOpen}
            />
            {path === MY_ACCOUNT &&
            <CurrentUserAccount/>
            }
            <Container>
                <Menu>
                    {choices.map(choice => (
                        <li key={choice.id}>
                            <StyledLink
                                to={choice.link}
                                className={`flex-row ${pathname.includes(choice.link) ? "selected-grey selected-item-menu" : ""}`}
                            >
                                <img src={choice.image} alt={"aller sur le Dashboard"}/>
                                <p> {choice.name} </p>
                            </StyledLink>
                        </li>
                    ))}
                </Menu>
                <Main>
                    {displaySections()}
                </Main>
            </Container>
        </Page>
    )
}

const Page = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: var(--color-white);
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  gap: 1rem;
  @media (min-width: 700px) {
    flex-direction: row;
    justify-content: space-between;
    gap: 0;
  }
`

const Menu = styled.ul`
  display: flex;
  width: fit-content;
  padding: 0.5rem 1rem;
  gap: 1em;
  background-color: var(--color-purple-lighten);
  margin-top: 2rem;
  border-radius: 10px;

  li {
    font-weight: 600;
    font-size: 110%;
  }

  p {
    display: none;
  }


  @media (min-width: 700px) {
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 15em;
    margin-top: 1rem;
    border-right: 1px solid rgba(166, 172, 181, 0.6);
    height: 100%;
    background-color: transparent;
    margin-left: 0;
    border-radius: 0;
    padding: 1rem 0 0 1rem;
    li {

      width: 100%;

      &:hover {
        background-color: var(--color-grey-06);
        border-radius: 10px 0 0 10px;
      }

    }

    p {
      display: initial
    }

    .selected-item-menu {
      border-right: 0.2rem solid var(--color-green);
    }
  }
`

const StyledLink = styled(Link)`
  display: flex;
  gap: 1em;
  align-items: center;
  border-radius: 10px;
  padding: 0.5em;
  width: 100%;
  @media (min-width: 700px) {
    border-radius: 10px 0 0 10px;
  }
`

export const Main = styled.div`
  height: 100%;
  width: 100%;

  @media (min-width: 768px) {
    padding-top: 32px;
  }

`
export default SettingsPage;